export default function() {
    const self = this

    self.mountCalendars()
    self.loadJobs()
    self.loadBusyDates()
}
